import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BanknoteIcon, UsersIcon, MessageCircleOffIcon } from 'lucide-react';
const problems = [{
  icon: BanknoteIcon,
  title: 'El dinero es motivo de guerra',
  description: <>
        Cada conversación sobre plata <strong data-id="element-203">termina en pelea</strong>. El
        estrés financiero se convirtió en el <em data-id="element-204">tercer integrante</em> de la
        relación.
      </>
}, {
  icon: UsersIcon,
  title: 'Socios, no amantes',
  description: <>
        Se sienten más como <strong data-id="element-205">compañeros de cuarto</strong> que como
        pareja. La logística diaria <em data-id="element-206">reemplazó a la intimidad</em>.
      </>
}, {
  icon: MessageCircleOffIcon,
  title: 'Silencio ensordecedor',
  description: <>
        Hablan de cuentas, horarios y problemas, pero hace meses que{' '}
        <strong data-id="element-207">no tienen una conversación real</strong> y profunda.
      </>
}];
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#0D002B]" data-id="element-208">
      <div className="max-w-6xl mx-auto px-6" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-20" data-id="element-210">
          <div className="inline-block bg-[#7C3AED]/20 text-[#C4B5FD] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-211">
            EL PROBLEMA REAL
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white font-serif" data-id="element-212">
            Cuando el mundo exterior <br className="hidden md:block" data-id="element-213" />
            <span className="text-[#E5A83B] italic" data-id="element-214">se mete en la cama</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12 mb-16" data-id="element-215">
          {problems.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.6,
            delay: index * 0.15,
            ease: 'easeOut'
          }} className="bg-[#E0D7FF] rounded-[20px] border border-white p-8 md:p-10 shadow-[0_10px_40px_-15px_rgba(124,58,237,0.15)] flex flex-col items-center text-center" data-id="element-216">
                <div className="w-16 h-16 bg-[#7C3AED]/20 rounded-full flex items-center justify-center mb-8" data-id="element-217">
                  <Icon className="w-8 h-8 text-[#7C3AED]" strokeWidth={2} data-id="element-218" />
                </div>
                <h3 className="text-xl font-bold text-[#1E0A3C] mb-4 font-serif leading-snug" data-id="element-219">
                  {item.title}
                </h3>
                <p className="text-[#3B1F6E] leading-relaxed font-sans font-medium text-lg" data-id="element-220">
                  {item.description}
                </p>
              </motion.div>;
        })}
        </div>

        <div className="text-center" data-id="element-221">
          <p className="text-[#C4B5FD] font-medium text-lg" data-id="element-222">
            👉 <em data-id="element-223">Pero hay una forma de revertir esto...</em>
          </p>
        </div>
      </div>
    </section>;
}